import React from 'react'
import { DataItemRow, Texto } from '@gravitate-js/excalibrr'
import { Col } from 'antd'
import { FormInput } from '@components/_SiteWide/Form/FormInput'

export const SourceInfo = ({ driver, editing }) => {
  return (
    <Col span={16} className='right-side'>
      <Texto category='h5'>{`Source Information`}</Texto>
      <div className='driver-form-line'>
        <DataItemRow label='Source ID' labelSpan={10} valueSpan={14} extraClass='mt-3'>
          <FormInput
            editable={editing}
            name='source_id'
            width='100%'
            placeholder='Source ID'
            initialValue={driver && <Texto align='right'>{driver.source_id}</Texto>}
          />
        </DataItemRow>
      </div>
      <div className='driver-form-line'>
        <DataItemRow label='Source System ID' labelSpan={10} valueSpan={14} extraClass='mt-3'>
          <FormInput
            editable={editing}
            name='source_system_id'
            width='100%'
            placeholder='Source System ID'
            initialValue={driver && <Texto align='right'>{driver.source_system_id}</Texto>}
          />
        </DataItemRow>
      </div>
    </Col>
  )
}
